const countFormatter = new Intl.NumberFormat("ko-KR");
const amountFormatter = new Intl.NumberFormat("ko-KR", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export const formatCount = (value: number): string => countFormatter.format(value);

/** 비용(P)은 소수 첫째 자리까지. 단가 8.4·25.9 의 배수라 그 이상은 생기지 않는다. */
export const formatAmount = (value: number): string => amountFormatter.format(value);
